import { render } from "./MainPrivilage.vue?vue&type=template&id=57d490a4&scoped=true"
import script from "./MainPrivilage.vue?vue&type=script&lang=js"
export * from "./MainPrivilage.vue?vue&type=script&lang=js"

import "./MainPrivilage.vue?vue&type=style&index=0&id=57d490a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d490a4"]])

export default __exports__